import { render, staticRenderFns } from "./SetsList.vue?vue&type=template&id=f0c9926a&"
import script from "./SetsList.vue?vue&type=script&lang=js&"
export * from "./SetsList.vue?vue&type=script&lang=js&"
import style0 from "./SetsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports